export const SubTitleMenuTranslationEN = {
  SubTitleMenu: {
    Title: 'サブタイトルメニュー一覧',
    Headers: {
      title: 'ジャンル詳細',
      add: 'ジャンル詳細',
    },
    Filter: {
      order_type: 'メニュー種別：',
      only_menu_child: 'サブメニューのみ表示',
      name: 'メニュー名：',
      code: 'メニューコード：',
      filter_delete: '削除データ：',
      hide_record_is_delete: '削除データ非表示',
      include_record_is_delete: '削除データ含めて表示',
      show_record_is_delete: '削除データのみ表示',
      date_of_expiry: '有効期限：',
      Show_valid_dates_below: '以下の日付に有効なものを表示',
    },
    Button: {
      select_all: '全選択',
      cancel_all: '解除',
      reload: 'リロード',
      detail: '詳細',
      delete: '削除',
      search: '絞り込み',
      export_csv: 'キッチンデシャップ通知用メニュー情報CSV出力 </br>（レジ情報除く）',
      import_csv: 'キッチンデシャップ通知用メニュー詳細情報CSV取込',
      link: '※キッチンデシャップ用メニュー詳細情報CSV取込テンプレート',
    },
    Table: {
      selection: '選択',
      code: 'メニューコード',
      name: 'メニュー名',
      type: 'メニュー種別',
      start_date: '開始',
      end_date: '終了',
    },
  },
  ModalSearch: {
    title: 'プレビュー',
    language: '言語：',
  },
};
